<template>
    <div id="dataBaseConnection" class="background-ash pl20 pr20 pb20" >
       <div class="search_list background-white">
		   <ul class="lists">
                <li>
                    <span>账号</span>
                    <el-input size="small" class="width180" @keyup.native.enter="searchGetDataList" v-model="getDataParam.mobile" placeholder="请输入账号"></el-input>
                </li>
                <li>
                    <span>企业名称</span>
                    <el-input size="small" class="width180" @keyup.native.enter="searchGetDataList" v-model="getDataParam.companyNameLike" placeholder="请输入企业名称"></el-input>
                </li>
                <li>
                    <span>状态</span>
                    <el-select size="small" class="select width180" v-model="getDataParam.status" >
                        <el-option label="全部" value="all"></el-option>
                        <el-option label="启用" value="ENABLED"></el-option>
                        <el-option label="禁用" value="DISABLED"></el-option>
                    </el-select>
                </li>
            </ul>
			<div class="btns">
                <el-button size="small" type="primary"  @click="searchGetDataList">搜索</el-button>
            </div>
	   </div>
       <!--内容-->
       <div class="pt20 content">
           <!--表头操作-->
           <div class="watchBar">
               <div class="total-user left color-blue">共计数据库信息{{totalCount}}个&emsp;&emsp;
                   启用：{{enabledCount}}个&emsp;&emsp;停用：{{disabledCount}}个</div>
               <div class="btns right">
                    <el-button size="small" class="export-right" type="primary" plain @click="getExport">导出</el-button>
                </div>
           </div>
           <!--表格-->
           <div class="tab">
               <el-table ref="checkList" :row-key="getRowKey" @selection-change="handleSelectionChange" size="mini" :data="dataList" tooltip-effect="dark" height="100%">
                   <el-table-column type="selection" width="50" :reserve-selection="true"></el-table-column>
                   <el-table-column label="序号" type="index"></el-table-column>
                   <el-table-column label="账号">
                        <template slot-scope="scope">{{ scope.row.mobile || '' }}</template>
                    </el-table-column>
                    <el-table-column label="企业名称" prop="companyName"></el-table-column>
                    <el-table-column label="数据库名称" prop="databaseName"></el-table-column>
                    <el-table-column label="类型" prop="databaseType"></el-table-column>
                    <el-table-column label="字符集" prop="databaseCharacter"></el-table-column>
                    <el-table-column label="IP" prop="databaseIp"></el-table-column>
                    <el-table-column label="端口" prop="databasePort"></el-table-column>
                    <el-table-column label="是否启用">
                        <template slot-scope="scope">
                            <span v-if="scope.row.status == 'ENABLED'" class="color-blue">启用</span>
                            <span v-else >停用</span>
                        </template>
                    </el-table-column>
               </el-table>
           </div>
           <div class="page background-white text-right p20">
                <el-pagination @size-change="changePageSize" @current-change="getDataList" :current-page.sync="getDataParam.page"
                :page-sizes="[10, 20, 50, 100]" :page-size="getDataParam.size" layout="total, sizes, prev, pager, next, jumper" :total="totalCount">
                </el-pagination>
            </div>
       </div>
    </div>
</template>

<script>
export default {
	name: 'dataBaseConnection', //数据库连接状态
	data () {
		return {
			getDataParam: {
				mobile: '',
                companyNameLike: '',
                status: 'all', //状态 ENABLED 启用；DISABLED禁用
				page:1,
				size:10
            },
            dataList: [],
            checkList: [],
            totalCount:0,
            enabledCount: 0, //启用总数
            disabledCount: 0, //停用总数
            loading: false,
		}
	},
	watch: {},
	methods: {
		searchGetDataList () {
            this.$refs.checkList.clearSelection();
            this.getDataParam.page = 1;
            this.getDataList();
        },
        //获取数据
        getDataList () {
            let param = {...this.getDataParam};
            param.page = (param.page - 1);
            param.status = (this.getDataParam.status == 'all'? null : this.getDataParam.status)
            const loading = this.load();
            this.$http('POST', '/admin/auto/configure/page', {}, param, (status, res) => {
                loading.close();
                this.getStatistics();
                if (status) {
                   if(!!res.content && res.content.length > 0) {
                       this.dataList = res.content;
                   }else {
                       this.dataList = [];
                   }
                   this.totalCount = res.totalCount;
                }
            })
        },
        getStatistics () {
            this.$http('POST', '/admin/auto/configure/state/count', {}, {
                mobile: this.getDataParam.mobile,
                companyNameLike: this.getDataParam.companyNameLike,
                status: this.getDataParam.status == 'all'? null : this.getDataParam.status
            }, (status, res) => {
                if (status) {
                   this.totalCount = res.data.totalCount;
                   this.enabledCount = res.data.enabledCount;
                   this.disabledCount = res.data.disabledCount;
                }
            })
        },
        changePageSize (val) {
            this.getDataParam.size = val;
            this.getDataParam.page = 1;
            this.getDataList();
        },
        handleSelectionChange (select) {
            this.checkList = select.map( (item) => { return item.id});
        },
        getExport () {
            let param = {
                ids: this.checkList,
                mobile: this.getDataParam.mobile,
                companyNameLike: this.getDataParam.companyNameLike,
                status: this.getDataParam.status == 'all'? null : this.getDataParam.status
            };
            if (param.ids <= 0) {
                param.ids = null;
            }
            const loading = this.load();
            this.$http('POST', '/admin/auto/configure/export', {}, param, (status, res) => {
                loading.close();
                if (status) {
                   if (res.status === '200') {
                       this.educe(res.data);
                   }
                }
            })
        },
        //勾选复选框
        getRowKey (row) {
            return row.id
        },

	},
	mounted () {
        this.getDataList();
	}
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
#dataBaseConnection {width: 100%;height: calc(100vh - 155px);}
#dataBaseConnection .content {height: calc(100% - 91px);}
#dataBaseConnection .content .tab {height: calc(100% - 125px);}
#dataBaseConnection >>>.el-table th.type>.cell, #userList >>>.el-table td.type>.cell {margin-left: 75px;}
#dataBaseConnection >>>.width400.el-input{width: 400px; height: 36px; border-radius: 2px;}
#dataBaseConnection >>>.width400.el-input .el-input__inner{width: 400px; height: 36px; border-radius: 2px;}
</style>



// WEBPACK FOOTER //
// src/views/automaticParity/databaseConnectionIfo.vue